import './index.scss';

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

class WFTextAndImageSlider {
    constructor(root) {
        this.root = root;
        this.navLocked = false;
        this.navUnlockTimer = null;

        let mainSplide = this.root.querySelector('.splide-main');
        if (mainSplide) {
            this.mainSplide = new Splide(mainSplide, {
                autoWidth: true,
                gap: 0,
                padding: 0,
                arrows: false,
                pagination: false,
            }).mount();

            this.mainSplideButtonPrev = this.root.querySelector('.splide-main__arrow--prev');
            this.mainSplideButtonNext = this.root.querySelector('.splide-main__arrow--next');

            this.bindArrow(this.mainSplideButtonPrev, '<');
            this.bindArrow(this.mainSplideButtonNext, '>');

            this.mainSplide.on('moved resized updated refreshed', () => {
                this.clearNavUnlockTimer();
                this.navLocked = false;
                this.syncArrowVisibility();
            });

            this.syncArrowVisibility();
        }
    }

    bindArrow(button, direction) {
        if (!button) {
            return;
        }

        button.addEventListener('click', (event) => {
            this.onArrowClick(event, direction);
        });
        // Extra guard against accidental double activation / zoom gestures.
        button.addEventListener('dblclick', (event) => {
            event.preventDefault();
        });
    }

    onArrowClick(event, direction) {
        event.preventDefault();

        if (this.navLocked || this.mainSplide.Components.Controller.isBusy()) {
            return;
        }

        this.navLocked = true;
        this.mainSplide.go(direction);

        // Unlock if Splide did not emit moved (e.g. already at end).
        this.clearNavUnlockTimer();
        this.navUnlockTimer = window.setTimeout(() => {
            this.navUnlockTimer = null;
            this.navLocked = false;
            this.syncArrowVisibility();
        }, 450);
    }

    clearNavUnlockTimer() {
        if (this.navUnlockTimer !== null) {
            window.clearTimeout(this.navUnlockTimer);
            this.navUnlockTimer = null;
        }
    }

    syncArrowVisibility() {
        const controller = this.mainSplide.Components.Controller;
        const index = this.mainSplide.index;
        const end = controller.getEnd();

        this.setArrowVisible(this.mainSplideButtonPrev, index > 0);
        this.setArrowVisible(this.mainSplideButtonNext, index < end);
    }

    setArrowVisible(button, visible) {
        if (!button) {
            return;
        }

        if (!visible && document.activeElement === button) {
            button.blur();
        }

        button.hidden = !visible;
        button.disabled = !visible;
        button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
}

window.app.run(() => {
    document.querySelectorAll('.text-and-image-slider').forEach((node) => {
        new WFTextAndImageSlider(node);
    });
});
